import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import WheelSearch from '@/components/search/WheelSearch/WheelSearch'
import { getPageTitle } from '@/utils/helpers'
import PageInfo from '@/components/common/PageInfo/PageInfo'
import Raw from '@/components/common/Raw/Raw'
import { useTranslation } from 'next-i18next'

type Props = {}

const WheelsPage = (props: Props) => {
  const { t } = useTranslation('common')

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('wheels:title'))}</title>
        <meta name="description" content={t('wheels:description') || ''} />
      </Head>
      <main>
        <PageInfo>          
          <h1>{t('wheels:header')}</h1>
          <Raw content={t('wheels:pageDescription')} />
        </PageInfo>
        <WheelSearch />
      </main>
    </BaseLayout>
  )
}

export default WheelsPage

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'rims',
      'wheels',
      'shop',
      'footer',
    ])),
  },
})